import { Alert, List, Stack, Text } from '@mantine/core';

import {
  isGroupSetupReadyToActivate,
  validateGroupActivation,
  type GroupSetupFormValues,
} from '@/lib/groupTherapy';

export interface GroupActivationChecklistProps {
  values: GroupSetupFormValues;
}

/**
 * Surfaces PRD §3 activation gaps when a draft group is not yet activatable.
 */
export function GroupActivationChecklist({
  values,
}: GroupActivationChecklistProps): JSX.Element | null {
  if (isGroupSetupReadyToActivate(values)) {
    return (
      <Alert color="green" title="Ready to activate" data-testid="group-activation-checklist">
        All activation requirements are met. Choose Save & Activate to open the cohort.
      </Alert>
    );
  }
  const gaps = validateGroupActivation({ ...values, active: true });
  return (
    <Alert color="yellow" title="Activation checklist" data-testid="group-activation-checklist">
      <Stack gap={4}>
        <Text size="sm">Complete these before the cohort can be activated (Save & Activate):</Text>
        <List size="sm" spacing={2}>
          {gaps.map((g) => (
            <List.Item key={`${g.field}-${g.message}`}>{g.message}</List.Item>
          ))}
        </List>
      </Stack>
    </Alert>
  );
}
